var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-more-button",class:{ 'show-more-button--up': _vm.isMore },on:{"click":_vm.changeStatus}},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.isMore ? '收起' : '查看更多')))]),_c('i',{staticClass:"iconfont icon-xiangxia"})])
}
var staticRenderFns = []

export { render, staticRenderFns }